import React from 'react';
import CollapsibleCard from './CollapsibleCard';
import { CodeIcon } from '../icons';

const CollapsibleCodeExecution: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <CollapsibleCard icon={<CodeIcon size={16} />} title="Code execution">
    {React.cloneElement(children as React.ReactElement, {
      noMargin: true
    })}
  </CollapsibleCard>
);

export default CollapsibleCodeExecution;
